import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  label: string;
}

export const BackButton = ({ label }: BackButtonProps) => {
  const navigate = useNavigate();

  const handleBackButton = () => {
    navigate('/');
  };
  return (
    <ps-button
      level="tertiary"
      id="back-link-for-your-documents"
      label={label}
      icon="caret-left"
      onClick={handleBackButton}
    ></ps-button>
  );
};
